import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loginData: {}, // 登录信息
    imgDomain: '', // 阿里云oss地址
    testName: ''
  },
  mutations,
  actions,
  plugins: [createPersistedState({ storage: window.sessionStorage })]
});

export default store;